module.exports = __webpack_public_path__ + "img/GREENZENLOS.0ddca422.png";